import { MAP_URL } from "../../constants/urls";

export function specialistTransactionListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function specialistTransactionMapperGetOneResponse(json) {
  return {
    data: {
      ...json.result,
      id: json.result.objectId,
      specialistTransactionId: json.result.objectId,
      conversationUrl: json.result.conversationId && MAP_URL.conversationAdminPanel + json.result.conversationId + "/show",
    },
  };
}

export function fixGetManySpecialistTransactions(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      specialistTransactionsId: resource.objectId,
    })),
  };
}
